import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { analyticsTrack } from '../../../analyticsUtils';
var valueText = function valueText(value, submenuTitle) {
  if (submenuTitle === 'Hourly Rate') return "$".concat(value, "/hr");
  return "".concat(value, " yrs");
};
var SliderSearchInput = /*#__PURE__*/function (_Component) {
  function SliderSearchInput(props) {
    var _this;
    _classCallCheck(this, SliderSearchInput);
    _this = _callSuper(this, SliderSearchInput, [props]);
    var defaultValue = props.defaultValue;
    _this.state = {
      currentValue: defaultValue
    };
    _this.reset = _this.reset.bind(_this);
    return _this;
  }
  _inherits(SliderSearchInput, _Component);
  return _createClass(SliderSearchInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var registerSliderResetFunction = this.props.registerSliderResetFunction;
      registerSliderResetFunction(this.reset);
    }
  }, {
    key: "reset",
    value: function reset() {
      var options = this.props.options;
      this.setState({
        currentValue: options
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        name = _this$props.name,
        options = _this$props.options,
        handleChange = _this$props.handleChange,
        submenuTitle = _this$props.submenuTitle;
      var currentValue = this.state.currentValue;
      var marks = _defineProperty(_defineProperty({}, options[0], valueText(options[0], submenuTitle)), options[1], valueText(options[1], submenuTitle));
      return /*#__PURE__*/React.createElement(Fragment, {
        key: submenuTitle
      }, /*#__PURE__*/React.createElement("div", {
        className: "subcontent-title"
      }, submenuTitle), /*#__PURE__*/React.createElement(Slider, {
        range: true,
        min: options[0],
        max: options[1],
        value: currentValue,
        marks: marks,
        onChange: function onChange(selection) {
          _this2.setState({
            currentValue: selection
          });
        },
        onChangeComplete: function onChangeComplete(selection) {
          analyticsTrack("Set ".concat(submenuTitle), {
            location: 'Search Index'
          });
          _this2.setState({
            currentValue: selection
          });
          handleChange(name, submenuTitle, selection);
        },
        ariaLabelForHandle: ["".concat(submenuTitle, " minimum"), "".concat(submenuTitle, " maximum")]
      }));
    }
  }]);
}(Component);
SliderSearchInput.propTypes = {
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  registerSliderResetFunction: PropTypes.func.isRequired,
  submenuTitle: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
  defaultValue: PropTypes.arrayOf(PropTypes.number).isRequired
};
export default SliderSearchInput;